const ENTER_TRANSITION_DURATION_MS = 100;
const outlineCls = "oaeo1mlpqdx";
const buttonCls = "oaebpc3d8a";
const overlayCls = "oaeo1t2ns4d";
const dialogCls = "oaed3q4yz";
const dialogButtonCls = "oaed19n4uj2";
const simplePlusCls = "oaes4axhp6";

export { ENTER_TRANSITION_DURATION_MS, buttonCls, dialogButtonCls, dialogCls, outlineCls, overlayCls, simplePlusCls };
import "./atom.add-to-course-builder.style.linaria.module.css";
//# sourceMappingURL=atom.add-to-course-builder.style.js.map
